import React, { Component } from "react";
import { Link } from "react-router-dom";

class AccountHomeButton extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="account-home-btn ">
          <Link to="/" className="text-black">
            <i className="mdi mdi-home h1"></i>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default AccountHomeButton;
